import { render, staticRenderFns } from "./ModalDuplicationFavoris.vue?vue&type=template&id=e623ba2c&"
import script from "./ModalDuplicationFavoris.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicationFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports